<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      title="我的兑换"
      :z-index="10"
      @click-left="goableBack()"></van-nav-bar>
    <div class="list-contain">
      <!-- 下拉刷新 -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad">
          <van-cell
            v-for="(item, index) in dataSource"
            :key="index"
            :border="false">
            <div
              class="contentbg"
              :style="
                'background-image: url(' +
                item.imgPath +
                ');background-size: 100% 100%;background-repeat: no-repeat;'
              ">
              <div class="title">{{ item.name }}&nbsp; {{ item.title }}</div>
              <template v-if="item.code == 2 && item.status.length > 0">
                <div class="coupon-tag-bg">
                  <van-tag class="coupon-tag">{{
                    getUndoStateName(parseInt(item.status))
                  }}</van-tag>
                </div>
              </template>
              <!-- chargeFlag:null,非充值卡，0未使用，1已充值 2充值中 -->
              <template v-else-if="item.chargeFlag != null">
                <div v-if="item.chargeFlag == 0" class="coupon-tag-bg">
                  <van-tag class="coupon-tag">未使用</van-tag>
                </div>
                <div v-else-if="item.chargeFlag == 1" class="coupon-tag-bg">
                  <van-tag class="coupon-tag">已充值</van-tag>
                </div>
                <div v-else class="coupon-tag-bg">
                  <van-tag class="coupon-tag">充值中</van-tag>
                </div>
              </template>
              <div class="topbg">
                <div class="left">
                  <!-- //code类型：1 加息券 2 代金券 3 京东E卡 4 盒马鲜生 5 黑猪礼品卡 6 话费充值卡 -->
                  <div v-if="item.code == 3 || item.code == 4">
                    <div
                      class="number"
                      id="number1"
                      @click="item.code == 4 ? onCopy('number1') : ''"
                      :data-clipboard-text="item.code == 4 ? item.prop1 : ''">
                      <span>卡号：{{ item.prop1 }}</span>
                      <van-tag
                        v-if="item.code == 4"
                        style="
                          padding: 0px 5px;
                          margin-left: 5px;
                          background-color: transparent;
                        "
                        color="rgba(236,236,236, 0.3)"
                        text-color="rgb(255, 255, 255)"
                        round
                        >复制</van-tag
                      >
                    </div>
                    <div
                      class="pwd"
                      id="pwd1"
                      @click="onCopy('pwd1')"
                      :data-clipboard-text="item.prop2">
                      <span>卡密：{{ item.prop2 }}</span>
                      <van-tag
                        style="
                          padding: 0px 5px;
                          margin-left: 5px;
                          background-color: transparent;
                        "
                        color="rgba(236,236,236, 0.3)"
                        text-color="rgb(255, 255, 255)"
                        round
                        >复制</van-tag
                      >
                    </div>
                  </div>
                  <div v-else-if="item.code == 5">
                    <div
                      class="number"
                      id="number3"
                      @click="onCopy('number3')"
                      :data-clipboard-text="item.prop2">
                      <span>提货密码：{{ item.prop2 }}</span>
                      <van-tag
                        style="
                          padding: 0px 5px;
                          margin-left: 5px;
                          background-color: transparent;
                        "
                        color="rgba(236,236,236, 0.3)"
                        text-color="rgb(255, 255, 255)"
                        round
                        >复制</van-tag
                      >
                    </div>
                    <div
                      class="pwd"
                      :style="'text-decoration: underline;'"
                      @click="onPickGoods(item)">
                      点击查看提货编码
                    </div>
                  </div>
                  <div v-else-if="item.code == 6">
                    <div
                      class="pwd"
                      :style="'text-decoration: underline;'"
                      @click="onPickGoods(item)">
                      点击填写充值号码
                    </div>
                  </div>
                  <div v-else>
                    <div class="number">&nbsp;</div>
                    <div class="pwd">&nbsp;</div>
                  </div>
                </div>
                <div class="right">
                  <template v-if="item.worth">
                    <span class="price">{{ item.worth }}</span>
                    <span class="unit">{{ item.unit }}</span>
                  </template>
                </div>
              </div>
              <div class="bottombg">
                <div class="time" v-if="item.code == 5">
                  使用方式：先识别提货编码，再输入提货密码
                </div>
                <div class="time" v-else-if="item.code == 6">
                  使用说明：填写充值号码并确认，后台将进行充值，充值时间为工作日8:30-17:30。偶尔因运营商接口不稳定导致充值未到账，请耐心等待。
                </div>
                <div class="time" v-else-if="item.code == 7">
                  注意事项：该商品为实物，小天将尽快联系供应商发货，若有任何疑问可联系微信小天客服或致电4006940070
                </div>
                <div class="time" v-else>
                  有效期：{{ dateFormat(item.beginTime, "YYYY年MM月DD日") }}-—{{
                    dateFormat(item.endTime, "YYYY年MM月DD日")
                  }}
                </div>
              </div>
              <div
                class="indexInner"
                :style="
                  item.isExpire == 1
                    ? 'background-color: rgba(55, 55, 55, 0.5);'
                    : 'background-color: none'
                "></div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <phone-change-pop
      :visible="showPhoneChange"
      :defaultPhone="defaultPhone"
      :isdisabled="isdisabled"
      @onSureClick="onSureClick"
      @onCloseClick="showPhoneChange = false" />
  </div>
</template>

<script >
import { Cell, List, PullRefresh, Tag, Toast } from "vant"
import * as MallApi from "@/api/mall"
import ClipboardJS from "clipboard"
import PhoneChangePop from "../../../components/PhoneChangePop.vue"
import { phoneCharge } from "../../../api/mall"
export default {
  components: {
    PhoneChangePop,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag
  },
  data() {
    return {
      refreshing: false,
      finished: false,
      loading: false,
      error: false,
      params: {
        pageNum: 1,
        pageSize: 10
      },
      dataSource: [],

      showPhoneChange: false,
      defaultPhone: "",
      isdisabled: false,
      phoneCharge: {
        gosid: "",
        phone: ""
      }
    }
  },
  methods: {
    onRefresh() {
      this.params.pageNum = 1
      //清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onLoad() {
      MallApi.getGoodsExchange(this.params)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.params.pageNum === 1) {
              this.finished = false
              this.dataSource = data
              //赋值给数据源
            } else {
              this.dataSource = this.dataSource.concat(data)
            }
            if (data.length < this.params.pageSize) {
              this.finished = true
            } else {
              this.params.pageNum++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    //提取货物
    onPickGoods(item) {
      if (item.code == 6) {
        this.defaultPhone = item.phone || ""
        this.isdisabled = item.chargeFlag == 0 ? false : true
        this.showPhoneChange = true
        this.phoneCharge.gosid = item.gosid
      } else {
        if (
          item.prop3.indexOf("http://") >= 0 ||
          item.prop3.indexOf("https://") >= 0
        ) {
          // console.log("item.prop3 == %O", item.prop3)
          // this.$router.push({
          //   name: "webview",
          //   params: {
          //     title: item.name + " " + item.title,
          //     // url: encodeURI(item.prop3)
          //     // url: encodeURI(
          //     //   "https://tuhe.th28.cn/MobileIntact.html#/MobileMod/cardScan/null"
          //     // )
          //     // url: encodeURI("https://www.baidu.com")
          //   }
          // })
          window.location.href = item.prop3
        }
      }
    },
    //添加卡号、卡密点击可复制功能
    onCopy(elementId) {
      let clipboard = new ClipboardJS(`#${elementId}`)
      clipboard.on("success", function (e) {
        Toast("已经复制到您的剪切板")
        e.clearSelection()
      })
      clipboard.on("error", function (e) {
        Toast("不支持自动复制，请手动复制")
      })
    },
    getUndoStateName(status) {
      // 0-未使用 1-已使用 2-已过期 3-已撤销
      let name = ""
      switch (status) {
        case 0:
          name = "可使用"
          break
        case 1:
          name = "已使用"
          break
        case 2:
          name = "已过期"
          break
        case 3:
          name = "已撤销"
          break

        default:
          break
      }
      return name
    },
    onSureClick(val) {
      this.phoneCharge.phone = val
      this._showLoading()
      phoneCharge(this.phoneCharge)
        .then((data) => {
          this._dismissLoading()
          this.showPhoneChange = false
          this.phoneCharge = {
            gosid: "",
            phone: ""
          }
          this.onRefresh()
          this._showTipsInfo(
            "温馨提示",
            "后台充值中，充值时间为工作日8:30-17:30，若遇法定节假日则正常顺延。充值遇到问题，可拨打客服热线4006940070或联系您的专属小天客服。",
            "",
            "关闭",
            () => {},
            () => {}
          )
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background-color: white;
}
.contentbg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 15px;
  color: white;
  font-size: 13px;
  .title {
    font-size: 16px;
    font-weight: 500;
    margin: 0 15px 0 15px;
    padding-top: 15px;
  }
  .coupon-tag-bg {
    position: absolute;
    top: 0px;
    right: 0;
    width: 80px;
    height: 35%;
    background-image: url("../../../assets/img/my-order/my_exchange_tag.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .coupon-tag {
      margin-top: -28px;
      padding-left: 35px;
      transform: rotate(35deg);
      background-color: transparent;
      color: red;
      font-size: 13px;
    }
  }
  .topbg {
    display: flex;
    justify-content: space-between;
    ::v-deep .van-tag {
      font-size: 11px;
      line-height: 15px;
    }
    .left {
      margin-left: 15px;
      margin-top: 15px;

      .number {
        margin-top: -5px;
      }
      .pwd {
        margin-top: -5px;
      }
    }
    .right {
      margin: auto 0;
      margin-right: 15px;
      .price {
        font-size: 26px;
        font-weight: 500;
        margin-right: 2px;
      }
    }
  }
  .bottombg {
    // border-top: 1px dashed white;
    margin-top: 10px;
    .time {
      margin: 0 15px;
      padding: 10px 0;
    }
  }
  .indexInner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 15px;
    pointer-events: none;
    cursor: default;
  }
}
</style>